 import Modal from './simple-modal.vue'
 import Vue from 'vue'
 import { forEach } from '@/libs/util'

 const modalConstructor = Vue.extend(Modal)

 let simpleModal = {}

 simpleModal.newInstance = (options) => {
   const instance = new modalConstructor({
     el: document.createElement('div')
   })
   document.body.appendChild(instance.$el)

   return {
     show (options) {
       if(!options['okText']) {
        options['okText'] = '确认'
       }
       if(!options['cancelText']) {
        options['cancelText'] = '取消'
       }
       if(!options['modalClass']) {
        options['modalClass'] = ''
       }
       forEach(Object.keys(options), (key) => {
         instance[key] = options[key]
       })
       instance.visible = true
     }
   }
 }

 export default simpleModal
